import React from "react";
import { Link } from "react-router-dom";

import logo from "../../assets/logos/gulftree-logos-final-white.svg";
import "./LogoMain.sass";

const LogoMain = ({ containerClassName }) => {
  return (
    <div className={`logo-main ${containerClassName || ""}`}>
      <Link to="/">
        <img src={logo} alt="Gulf TREE logo" />
      </Link>
    </div>
  );
};

export default LogoMain;
